import { fromJS } from 'immutable';
import { ApiUrl5, UserToken } from '../../../helper/HelperAuth'
import { GetTicketHour } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (body) => async (dispatch, getState) => {
    const Authorization = UserToken;   
    const url = ApiUrl5 + 'total-tickets-by-hour';
    const argument = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': Authorization,
        },
        body: JSON.stringify(body)
    };

    const response = await doFetch(url, argument);
    var data = fromJS({});
    if (response.ok) {
        data = fromJS(await response.json());
        data = data.get("total-tickets")
        var x = []
        for (var i = 0; i < data.size; i++) {
            var datinti = data.get(i)
            var jam = datinti.get("jam")
            if(jam[0] == "0"){
                jam = jam.substring(1,2)
            }else{
                jam = jam.substring(0,2)
            }
            var obj = { name:jam}
            obj["total-tickets"] = parseInt(datinti.get("total-tickets"))
            x.push(obj)

        }
        data=x 
    }
    dispatch({ type: GetTicketHour, data:fromJS(data)});
    return data
};